import React from 'react';

import {
  Panel,
  PanelHeader,
  PanelHeaderBack,
} from '@vkontakte/vkui';

import styles from './index.module.css';
import { DesktopUserEnteringPanelProps } from './types';
import { useRouter } from '../../../../hooks/useRouter';
import { UserEnteringPage } from '../../pages/UserEnteringPage';

export const DesktopUserEnteringPanel:React.FC<DesktopUserEnteringPanelProps> = ({ id }) => {
  const router = useRouter();
  const  onBackClick = router.back;

  return (
    <Panel id={id} className={styles.panel}>
      <PanelHeader before={<PanelHeaderBack onClick={onBackClick}/>}>
        AI-профориентатор
      </PanelHeader>
      <UserEnteringPage/>
    </Panel>
  );
};
